import { memo } from "react";
import User from "./User";
import Project from "./Project";
import { sortEntityColumn } from "../lib/sortEntityColumn";
import { icons } from "../../default_images/IconsList";
import PropTypes from "prop-types";
import { TeambookIcon } from "../../default_images/TeambookIcon";
import TeambookSortingTypes from "../../default_components/TeambookSortingTypes";

const UsersColumn = ({
  users,
  selectedUser,
  setSelectedUser,
  sortMode,
  allUserLogs,
  date,
  setSortMode,
  setSplitBy,
  splitBy,
  projects,
}) => {
  const sortTypes = {
    by_user: ["user", "delta_hours"],
    by_project: ["project", "delta_hours"],
  };

  return (
    <div className="users-column">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          gap: 10,
          paddingBottom: 16,
          marginTop: 2,
        }}
      >
        <TeambookSortingTypes
          className="users-column__sorting-types"
          dropdownOffsetBottom={5}
          filterOrder={sortMode}
          setFilterOrder={setSortMode}
          sortingTypes={sortTypes[splitBy]}
        />

        <div className="users-column__split-switcher">
          <div className="users-column__split-switcher-buttons">
            <div
              className={`users-column__split-switcher-buttons-button ${splitBy === "by_user" ? "active" : ""}`}
              onClick={() => setSplitBy("by_user")}
            >
              <TeambookIcon name={icons.USERS} />
            </div>
            <div
              className={`users-column__split-switcher-buttons-button ${splitBy === "by_project" ? "active" : ""}`}
              onClick={() => setSplitBy("by_project")}
            >
              <TeambookIcon name={icons.HEADER_PROJECT} />
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 20,
          overflowY: "auto",
          height: "100%",
          width: 336,
        }}
      >
        {sortEntityColumn(splitBy, users, projects, sortMode, date, allUserLogs).map((entity) =>
          splitBy === "by_user" ? (
            <User
              key={entity.id}
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
              user={entity}
              allUserLogs={allUserLogs.filter((log) => log.user_id === entity.id)}
              date={date}
            />
          ) : (
            <Project
              key={entity.id}
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
              project={entity}
              allUserLogs={allUserLogs.filter((log) => log.project_id === entity.id)}
              date={date}
            />
          )
        )}
      </div>
    </div>
  );
};

UsersColumn.propTypes = {
  users: PropTypes.array.isRequired,
  selectedUser: PropTypes.object.isRequired,
  setSelectedUser: PropTypes.func.isRequired,
  sortMode: PropTypes.string.isRequired,
  allUserLogs: PropTypes.array.isRequired,
  date: PropTypes.object.isRequired,
  setSortMode: PropTypes.func.isRequired,
  setSplitBy: PropTypes.func.isRequired,
  splitBy: PropTypes.string.isRequired,
  projects: PropTypes.array.isRequired,
};
export default memo(UsersColumn);
